/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CompanyFundingRoundSchema } from './companyFundingRoundSchema';
import type { CompanySocialLinkSchema } from './companySocialLinkSchema';

export interface CompanySummaryResponse {
  name: string;
  domain?: string | null;
  industry?: string | null;
  description?: string | null;
  industry_tags?: string[];
  social_links?: CompanySocialLinkSchema[];
  founded?: number | null;
  size?: string | null;
  employee_count?: number | null;
  location?: string | null;
  latest_funding_stage?: string | null;
  total_funding_raised?: number | null;
  funding_rounds?: CompanyFundingRoundSchema[];
  tags?: string[];
  website?: string | null;
  ticker?: string | null;
}
